import { isNil } from 'lodash';
import React, { useContext } from 'react';
import { MBView } from '@shared/components/MBView';
import { View } from '@shared/components/View';
import { MBHover } from '@shared/components/hover';
import { MBBoxedIcon, MBIconV2, MBIconV2Name, MBImage, getIconV2 } from '@shared/components/image';
import { MBTextBody1 } from '@shared/components/typography';
import { ColorThemeContext, cursorPointerStyle, grid } from '@shared/styles';

interface Props {
  defaultIcon: MBIconV2Name;
  selectedIcon: MBIconV2Name;
  imageUrl?: string;
  name: string;
  enabled?: boolean;
  isBoxedSelectedIcon?: boolean;
}

export function NestedOptionsRow({
  defaultIcon,
  selectedIcon,
  imageUrl,
  name,
  enabled = true,
  isBoxedSelectedIcon = true,
}: Props) {
  const colors = useContext(ColorThemeContext);
  const textColor = colors.foregroundActive;

  const rightIcon = enabled ? 'arrow-point-right' : 'lock';
  const LeftView = () => {
    if (enabled && isNil(imageUrl)) {
      return <MBIconV2 name={defaultIcon} color={textColor} size={grid(3)} />;
    }
    if (isNil(imageUrl)) {
      if (isBoxedSelectedIcon) {
        return (
          <MBBoxedIcon
            source={getIconV2(selectedIcon)}
            color={colors.avatar.foreground}
            backgroundColor={colors.avatar.background}
            size={'small'}
          />
        );
      } else {
        return <MBIconV2 name={selectedIcon} color={textColor} size={grid(3)} />;
      }
    }
    return <MBImage source={{ uri: imageUrl }} style={{ height: grid(3), width: grid(3) }} />;
  };

  return (
    <MBView style={enabled ? cursorPointerStyle : null}>
      <MBHover
        hoverStyle={enabled && { backgroundColor: colors.input.backgroundInactive }}
        centerVertically
      >
        <View row centerVertically paddingVertical={1} paddingHorizontal={3}>
          <LeftView />
          <View fill centerVertically paddingLeft={1}>
            <MBTextBody1 color={textColor}>{name}</MBTextBody1>
          </View>
          <MBIconV2 name={rightIcon} color={textColor} size={grid(3)} />
        </View>
      </MBHover>
    </MBView>
  );
}
